import React from 'react';
import styles from './GlobalPhotoUploadStatus.module.css';
import { useAllPhotoUploads } from '../utils/photoUploadManager';

const labelForStatus = (status: string, progress: number) => {
  if (status === 'uploading') return `Uploading ${progress}%`;
  if (status === 'saving') return 'Saving photo...';
  if (status === 'done') return 'Photo saved';
  return 'Upload failed';
};

const GlobalPhotoUploadStatus = () => {
  const uploads = useAllPhotoUploads().filter(
    (task) => task.status === 'uploading' || task.status === 'saving' || task.status === 'error'
  );

  if (uploads.length === 0) return null;

  return (
    <div className={styles.container} aria-live="polite">
      {uploads.map((task) => (
        <div key={task.key} className={styles.card}>
          <div className={styles.headerRow}>
            <div className={styles.title}>
              {task.entityType === 'artist' ? 'Artist photo' : 'Album photo'}
            </div>
            <div className={styles.status}>{labelForStatus(task.status, task.progress)}</div>
          </div>
          <div className={styles.fileName} title={task.fileName}>
            {task.fileName}
          </div>
          <div className={styles.progressTrack}>
            <div
              className={`${styles.progressBar} ${task.status === 'error' ? styles.progressBarError : ''}`}
              style={{ width: `${task.status === 'error' ? 100 : task.progress}%` }}
            />
          </div>
          {task.status === 'error' && task.error && <div className={styles.error}>{task.error}</div>}
        </div>
      ))}
    </div>
  );
};

export default GlobalPhotoUploadStatus;
